export default "__VITE_ASSET__dFECcWId__"